// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"Header_appHeader__iVZBX","tasteLogo":"Header_tasteLogo__2gYsp"};